"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.timestampToDate = exports.startOfDay = exports.parseTimeStamp = exports.isWithinOneWeek = exports.createTimeSince = exports.createTimeRange = exports.createTime = exports.createRelativeTimeString = exports.UNIX_EPOCH = exports.ONE_YEAR = exports.ONE_WEEK = exports.ONE_SECOND = exports.ONE_MONTH = exports.ONE_MINUTE = exports.ONE_HOUR = exports.ONE_DAY = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _d3TimeFormat = require("d3-time-format");
/**
 * This module is concerned with formatting dates and time (as returned from the
 * ES listings API) for display. All timestamps in ES are returned with a time
 * + time offset from UTC/GMT. Those times need to be displayed as they are
 * (with formatting + without offset), ignoring the clients local time. The
 * easiset way to acheive this universally is to treat all times as if they
 * were UTC, and all users we in the GMT time zone.
 *
 * NOTE: We need to keep an eye on this, if the format of ES timestamps changes
 * these functions will need to change their behaviour.
 */
/**
 * NOTE: These are allow for consisent parsing and formatting of dates
 * in this module as there appears to be some inconsistencies between
 * real browsers and IE. This is very much a stop-gap, I intend to
 * rewrite this entire utility library using the d3-time-format module.
 */
var parseFull = (0, _d3TimeFormat.utcParse)('%Y-%m-%dT%H:%M:%S');
var parseShort = (0, _d3TimeFormat.utcParse)('%Y-%m-%d');
var parse = timestamp => parseFull(timestamp) || parseShort(timestamp);
var format = (0, _d3TimeFormat.utcFormat)('%Y|%B|%d|%A|%I:%M|%p');
var ONE_SECOND = exports.ONE_SECOND = 1000;
var ONE_MINUTE = exports.ONE_MINUTE = ONE_SECOND * 60;
var ONE_HOUR = exports.ONE_HOUR = ONE_MINUTE * 60;
var ONE_DAY = exports.ONE_DAY = ONE_HOUR * 24;
var ONE_WEEK = exports.ONE_WEEK = ONE_DAY * 7;
var ONE_MONTH = exports.ONE_MONTH = ONE_DAY * 30;
var ONE_YEAR = exports.ONE_YEAR = ONE_DAY * 365;
var UNIX_EPOCH = exports.UNIX_EPOCH = '1970-01-01';

/**
 * Parses the timestamps that are returned from the ES api and creates a
 * date object out of them.  This drops the milliseconds and TZ offset
 * information from the timestamp if present.
 *
 * @param {String} timestamp
 *
 * @returns {Object} a JS Date object
 */
var parseTimeStamp = timestamp =>
// `2016-04-06T12:24:14.000+10:00` => `2016-04-06T12:24:14`
parse(timestamp.replace(/(\.\d{1,3})?([+-]\d{2}:\d{2})?$/, ''));

/**
 * createTimeObj, takes a timestamp (like above) and returns an object
 * containing a `time` object. A time object contains `year`, `month`,
 * `date`, `day`, `hours`, `minutes`, `meridiem`.
 *
 * @param {Object} a JS date object
 *
 * @returns {Object} a `time` object
 */
exports.parseTimeStamp = parseTimeStamp;
var createTimeObj = date => {
  var [year, month, _date, day, time, meridiem] = format(date).split('|');
  return {
    year,
    month,
    date: _date[0] === '0' ? _date[1] : _date,
    day,
    time: time[0] === '0' ? (0, _slice.default)(time).call(time, 1) : time,
    meridiem: meridiem.toLowerCase(),
    ms: date.getTime()
  };
};
var createTime = timestamp => createTimeObj(parseTimeStamp(timestamp));

/**
 * createTimeRangeObj, takes two timestamps (like above) and returns an object
 * containing a `timeRange` object. A timeRange object contains `year`, `month`,
 * `date`, `day`, `hours`, `start`: { 'minutes', `meridiem` },
 * `end`: { 'minutes', `meridiem` }.
 *
 * @param {Object} a JS date object
 *
 * @returns {Object} a `timeRange` object
 */
exports.createTime = createTime;
var createTimeRangeObj = (start, end) => {
  var {
    date,
    day,
    meridiem,
    month,
    ms,
    time,
    year
  } = createTimeObj(start);
  var {
    meridiem: _meridiem,
    ms: _ms,
    time: _time
  } = createTimeObj(end);
  return {
    year,
    month,
    date,
    day,
    start: {
      time,
      meridiem,
      ms
    },
    end: {
      time: _time,
      meridiem: _meridiem,
      ms: _ms
    }
  };
};

/**
 * Produces a time range used where events have a start and finish.
 *
 * @param {String} start time (whatever format ES returns)
 * @param {String} end time (same)
 *
 * @returns {Object} a time range object
 */
var createTimeRange = (a, b) => createTimeRangeObj(parseTimeStamp(a), parseTimeStamp(b));

/**
 * Rounds the given timestamp to the start of the day.
 */
exports.createTimeRange = createTimeRange;
var startOfDay = time => Math.floor(time / ONE_DAY) * ONE_DAY;

/**
 * Determines if a date is within the next week.
 *
 * @param {Number} the current UTC time
 * @param {Date} the events date as a `Date` object
 *
 * @returns {Boolean}
 */
exports.startOfDay = startOfDay;
var isWithinOneWeek = (UTCTimeNow, eventTime) => {
  var UTCTimeOfEvent = eventTime.getTime();
  var diff = startOfDay(UTCTimeOfEvent) - startOfDay(UTCTimeNow);
  if (diff >= 0 && diff < ONE_WEEK) return true;
  return false;
};

/**
 * Produces the string used on listing to indicate a proximate inspection or auction.
 *
 * @param {Number} - the current UTC time
 * @param {String} - the event time string
 * @param {String} - the event type (Open/Auction)
 *
 * @returns {String}
 */
exports.isWithinOneWeek = isWithinOneWeek;
var createRelativeTimeString = (UTCTimeNow, eventTimeString, eventType) => {
  var _context4;
  var eventTime = parseTimeStamp(eventTimeString);
  var {
    date,
    day,
    month
  } = createTimeObj(eventTime);
  if (!isWithinOneWeek(UTCTimeNow, eventTime)) {
    var _context, _context2, _context3;
    if (eventType === 'Open') {
      return '';
    }
    return (0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "".concat(eventType, " ")).call(_context3, (0, _slice.default)(day).call(day, 0, 3), " ")).call(_context2, date, " ")).call(_context, month);
  }
  return startOfDay(UTCTimeNow) === startOfDay(eventTime) ? "".concat(eventType, " Today") : (0, _concat.default)(_context4 = "".concat(eventType, " ")).call(_context4, createTimeObj(eventTime).day);
};

/**
 * Used to generate the string returned by `createTimeSince`.
 *
 * @param {Number} - different (milliseconds) between two events
 * @param {Number} - the period to describe the difference in
 * @param {String} - the a string singular for that difference
 *
 * @return {String} - a string representing elapsed time
 */
exports.createRelativeTimeString = createRelativeTimeString;
var timeSince = (difference, period, str) => {
  var _context5, _context6;
  var num = Math.floor(difference / period);
  return (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "".concat(num, " ")).call(_context6, str)).call(_context5, num > 1 ? 's' : '', " ago");
};

/**
 * Takes a UTC timestamp and returns a string representation of the
 * time elapsed since then.
 * TODO: Write some tests.
 * TODO: Pass in the current time for testing.
 *
 * @param {Number} - time now in ms
 * @param {String} - a UTC timestamp in a format parsable by `new Date()`
 *
 * @returns {String}
 */
var createTimeSince = (now, timestamp) => {
  var diff = now - new Date(timestamp);
  switch (true // For Liam :}
  ) {
    case diff > ONE_YEAR:
      return timeSince(diff, ONE_YEAR, 'year');
    case diff > ONE_MONTH:
      return timeSince(diff, ONE_MONTH, 'month');
    case diff > ONE_WEEK:
      return timeSince(diff, ONE_WEEK, 'week');
    case diff > ONE_DAY:
      return timeSince(diff, ONE_DAY, 'day');
    default:
      return 'today';
  }
};
exports.createTimeSince = createTimeSince;
var timestampToDate = timestamp => new Date(timestamp).toISOString().substr(0, 10);
exports.timestampToDate = timestampToDate;